import "../Styles/shell.scss";
import "@coso/layout/external-dependencies";
import { defineCustomElements, } from '@coso/layout/loader';
import {  ThemeManager } from '@coso/layout';
defineCustomElements();

ThemeManager.instance.initialize(false);
const urlSearchParams = new URLSearchParams(window.location.search);
const theme = urlSearchParams.get("theme");
if (theme) {
    ThemeManager.instance.setTheme(theme);
}